export var FlightSort;
(function (FlightSort) {
    FlightSort.byScheduledTimeAndAirport = (a, b) => a.scheduledTimestamp - b.scheduledTimestamp ||
        a.viaAirport.localeCompare(b.viaAirport);
})(FlightSort || (FlightSort = {}));
//# sourceMappingURL=FlightSort.js.map